<!-- NOT: Ölçüm Modu Kumpas -->
<div style="display: flex;flex-direction:column;">
    <select name="cars" id="cars" style="width: 100%;outline:none;" [(ngModel)]="secim1Turu">
        <option value="Her Şey">Her Şey</option>
        <option value="Sadece Nokta">Sadece Nokta</option>
        <option value="Sadece Çizgi">Sadece Çizgi</option>
        <option value="Sadece Yüzey">Sadece Yüzey</option>
        <option value="Sadece Gruplar">Sadece Gruplar</option>
        <option value="Nokta Koy">Nokta Koy</option>
    </select>

    <div class="ui divider" style="margin-top: 0.1rem;margin-bottom:0.1rem;"></div>

    <!-- NOT: Seçim Türü Sadece Nokta -->
    <div>
        <div style="display: flex; flex-direction: row;">
            Diğer Eksen :
            <div style="display: flex;flex:1;">
                <button class="ui icon button" style="padding: 0.2rem;" (click)="tiklandiEksenSil();">
                    <i class="creative commons zero icon"></i>
                </button>
                <input class="fikoinput" type="text" placeholder="Seç" size="1" style="flex:1;" disabled
                    [ngModel]="kumpasEksen?.name || 'Seçilmemiş'">
                <button class="ui icon button" style="padding: 0.2rem;" (click)="tiklandiEksenSec();">
                    <i class="mouse pointer icon"></i>
                </button>
            </div>
        </div>

        <div class="ui divider" style="margin-top: 0.1rem;margin-bottom:0.1rem;"></div>

        <div style="display: flex; flex-direction: row;">
            <span>Hesaplama Modu :</span>
            <select name="cars" id="cars" style="outline:none;">
                <option value="kesinolmazsayaklasik">Kesin, Olmazsa Yaklaşık</option>
                <option value="kesin">Kesin</option>
                <option value="yaklasik">Yaklaşık</option>
            </select>
        </div>
    </div>

    <!-- NOT:  Sonuç -->

    <div class="ui horizontal divider header"
        style="margin-top: 0.1rem;margin-bottom:0.1rem;color: white;text-transform: unset;font-size:0.8rem;">
        Sonuç:
    </div>

    <!-- GPU Mode Badge -->
    <div style="padding: 0.3rem; text-align: center; font-size: 0.7rem; margin-bottom: 0.3rem;">
        <span [ngStyle]="{
            'background': gpuMode === 'WEBGPU' ? '#00ff00' : gpuMode === 'WASM' ? '#ffaa00' : '#ff4444',
            'color': '#000',
            'padding': '0.2rem 0.5rem',
            'border-radius': '3px',
            'font-weight': 'bold'
        }">
            {{ gpuMode === 'WEBGPU' ? '🚀 GPU' : gpuMode === 'WASM' ? '⚡ WASM' : '🐢 CPU' }}
        </span>
    </div>


    <div *ngIf="!sonucTipi" style="text-align: center;">
        Herhangi Bir Seçim Yapılmadı
    </div>

    <div *ngIf="sonucTipi=='Nokta'">
        <!-- BİLGİ:  XYZ Koordinatlar -->
        Nokta:
        <div style="display: flex; flex-direction: row;">
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                X:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.nokta?.x
                    }}<sup>mm</sup></a>
            </div>
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                Y:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.nokta?.y
                    }}<sup>mm</sup></a>
            </div>
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                Z:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.nokta?.z
                    }}<sup>mm</sup></a>
            </div>
        </div>
    </div>

    <div *ngIf="sonucTipi=='Yüzey'">
        <!-- BİLGİ:  Yüzey Tipi -->
        Yüzey Tipi: <strong>{{ sonuc?.yuzey?.tipi | uppercase }}</strong>
        <div style="display: flex; flex-direction: row;">
            <div class="ui fluid label" style="flex: 1;padding: 0.3rem;">
                Yüzey Alanı:
                <a class="detail" style="color: black;">{{ (sonuc?.yuzey?.alan | number:'1.4-10') }}mm<sup>2</sup></a>
            </div>
        </div>

        <!-- Yüzey Tipi Bilgileri -->
        <div *ngIf="sonuc?.yuzey?.tipi === 'silindir'" style="background-color: #f0f0f0; padding: 0.3rem; margin: 0.2rem 0; border-radius: 4px;">
            <strong>Silindir Bilgileri:</strong>
            <div style="display: flex; flex-direction: row; margin-top: 0.2rem;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Yaricap:
                    <a class="detail" style="color: black;">{{ sonuc?.yuzey?.tipiBilgisi?.radius }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Dogruluk:
                    <a class="detail" style="color: black;">{{ sonuc?.yuzey?.tipiBilgisi?.accuracy }}</a>
                </div>
            </div>
        </div>

        <div *ngIf="sonuc?.yuzey?.tipi === 'kure'" style="background-color: #f0f0f0; padding: 0.3rem; margin: 0.2rem 0; border-radius: 4px;">
            <strong>Kure Bilgileri:</strong>
            <div style="display: flex; flex-direction: row; margin-top: 0.2rem;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Yaricap:
                    <a class="detail" style="color: black;">{{ sonuc?.yuzey?.tipiBilgisi?.radius }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Dogruluk:
                    <a class="detail" style="color: black;">{{ sonuc?.yuzey?.tipiBilgisi?.accuracy }}</a>
                </div>
            </div>
        </div>

        <div *ngIf="sonuc?.yuzey?.tipi === 'duzlem'" style="background-color: #f0f0f0; padding: 0.3rem; margin: 0.2rem 0; border-radius: 4px;">
            <strong>Duzlem Bilgileri:</strong>
            <div style="display: flex; flex-direction: row; margin-top: 0.2rem;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Planarity:
                    <a class="detail" style="color: black;">{{ sonuc?.yuzey?.tipiBilgisi?.planarity }}</a>
                </div>
            </div>
        </div>

        Agirlik Merkezi:
        <div style="display: flex; flex-direction: row;">
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                X:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                    sonuc?.yuzey?.agirlikMerkezi?.x?.toFixed(4) }}<sup>mm</sup></a>
            </div>
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                Y:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                    sonuc?.yuzey?.agirlikMerkezi?.y?.toFixed(4) }}<sup>mm</sup></a>
            </div>
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                Z:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                    sonuc?.yuzey?.agirlikMerkezi?.z?.toFixed(4) }}<sup>mm</sup></a>
            </div>
        </div>

        Duzlem : {{ sonuc?.yuzey?.miDuzlemsel ? " Yuzey Duzlemdir":" Yuzey Duzlemsel Degildir" }}
        <div style="display: flex; flex-direction: row;">
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                I:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                    sonuc?.yuzey?.duzlem?.normal?.x?.toFixed(6) }}</a>
            </div>
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                J:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                    sonuc?.yuzey?.duzlem?.normal?.y?.toFixed(6) }}</a>
            </div>
            <div class="ui label" style="flex: 1;padding: 0.3rem;">
                K:
                <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                    sonuc?.yuzey?.duzlem?.normal?.z?.toFixed(6) }}</a>
            </div>
        </div>
        <div class="ui label" style="padding: 0.3rem;width:100%;margin-top: 0.2rem;">
            Düzlem Mesafe:
            <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                sonuc?.yuzey?.duzlem?.constant?.toFixed(6) }}<sup>mm</sup></a>
        </div>

    </div>

    <div *ngIf="sonucTipi=='Çizgi'">
        <!-- BİLGİ:  XYZ Koordinatlar -->
        Çizgi: {{ sonuc?.cizgi?.miDuzlemsel ? " Çizgi Bir Yön Belirtir":" Çizgi Yön Belirtmez" }}
        <div style="display: flex; flex-direction: row;">
            <div class="ui fluid label" style="flex: 1;padding: 0.3rem;">
                Uzunluk:
                <a class="detail" style="color: black;">{{ sonuc?.cizgi?.uzunluk.toFixed(6) }}<sup>mm</sup></a>
            </div>
        </div>
        <div *ngIf="sonuc?.cizgi?.cember">
            <div style="display: flex; align-items: center; gap: 4px;">
                Çembersel:
                <span *ngIf="sonuc?.cizgi?.cember?.brepKesin"
                    style="background: #00c853; color: #fff; padding: 1px 5px; border-radius: 3px; font-size: 0.65rem; font-weight: bold;">
                    BREP
                </span>
                <span *ngIf="!sonuc?.cizgi?.cember?.brepKesin"
                    style="background: #ff9800; color: #fff; padding: 1px 5px; border-radius: 3px; font-size: 0.65rem; font-weight: bold;">
                    Yaklaşık
                </span>
            </div>
            <!-- Büyük Çap/Radius Gösterimi -->
            <div style="background: linear-gradient(135deg, #1a237e 0%, #0d47a1 100%); border-radius: 6px; padding: 0.5rem; margin: 0.3rem 0; text-align: center;">
                <div style="color: #90caf9; font-size: 0.7rem; margin-bottom: 2px;">Çap (Diameter)</div>
                <div style="color: #fff; font-size: 1.3rem; font-weight: bold; letter-spacing: 0.5px;">
                    Ø {{ sonuc?.cizgi?.cember?.cap?.toFixed(4) }} <span style="font-size: 0.8rem; opacity: 0.8;">mm</span>
                </div>
                <div style="color: #90caf9; font-size: 0.7rem; margin-top: 4px;">Yarıçap (Radius)</div>
                <div style="color: #e3f2fd; font-size: 1.0rem; font-weight: bold;">
                    R {{ sonuc?.cizgi?.cember?.yariCap?.toFixed(4) }} <span style="font-size: 0.7rem; opacity: 0.8;">mm</span>
                </div>
            </div>
            <div style="display: flex; flex-direction: row;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Yarı Çap (R):
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.yariCap?.toFixed(6) }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Çap (Ø):
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.cap?.toFixed(6) }}<sup>mm</sup></a>
                </div>
            </div>
            Çember Merkezi:
            <div style="display: flex; flex-direction: row;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    X:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.merkez?.x?.toFixed(4) }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Y:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.merkez?.y?.toFixed(4) }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Z:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.merkez?.z?.toFixed(4) }}<sup>mm</sup></a>
                </div>
            </div>
            Açı:
            <div style="display: flex; flex-direction: row;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Açısı:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.aci?.toFixed(6) }}<sup>derece</sup></a>
                </div>
            </div>
            Nokta 1:
            <div style="display: flex; flex-direction: row;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    X:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.nokta1?.x?.toFixed(4) }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Y:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.nokta1?.y?.toFixed(4) }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Z:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.nokta1?.z?.toFixed(4) }}<sup>mm</sup></a>
                </div>
            </div>
            Nokta 2:
            <div style="display: flex; flex-direction: row;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    X:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.nokta2?.x?.toFixed(4) }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Y:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.nokta2?.y?.toFixed(4) }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Z:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.cember?.nokta2?.z?.toFixed(4) }}<sup>mm</sup></a>
                </div>
            </div>
        </div>

        <div *ngIf="sonuc?.cizgi?.yon">
            Yön :
            <div style="display: flex; flex-direction: row;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    I:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.yon?.x?.toFixed(6) }}</a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    J:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.yon?.y?.toFixed(6) }}</a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    K:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{
                        sonuc?.cizgi?.yon?.z?.toFixed(6) }}</a>
                </div>
            </div>
        </div>

        <!-- BILGI: Cizgi Egriligi -->
        <div *ngIf="sonuc?.cizgi?.egriliBilgi" style="background-color: #fff3cd; padding: 0.3rem; margin: 0.2rem 0; border-radius: 4px;">
            <strong>Egrilik Bilgileri:</strong>
            <div style="display: flex; flex-direction: row; margin-top: 0.2rem;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Tipi:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.cizgi?.egriliBilgi?.tipi | uppercase }}</a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Oran:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.cizgi?.egriliBilgi?.egriliBilim }}</a>
                </div>
            </div>
            <div style="display: flex; flex-direction: row; margin-top: 0.1rem;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Max Sapma:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.cizgi?.egriliBilgi?.maxSapma }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Ort. Sapma:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.cizgi?.egriliBilgi?.ortaSapma }}<sup>mm</sup></a>
                </div>
            </div>
            <div style="display: flex; flex-direction: row; margin-top: 0.1rem;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Ort. Aci:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.cizgi?.egriliBilgi?.ortaAci }}<sup>derece</sup></a>
                </div>
            </div>
            <div style="display: flex; flex-direction: row; margin-top: 0.1rem;">
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Gercek Uzunluk:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.cizgi?.egriliBilgi?.gercekUzunluk }}<sup>mm</sup></a>
                </div>
                <div class="ui label" style="flex: 1;padding: 0.3rem;">
                    Duz Uzunluk:
                    <a class="detail" style="color: black;margin-left: 0.1rem;">{{ sonuc?.cizgi?.egriliBilgi?.duzUzunluk }}<sup>mm</sup></a>
                </div>
            </div>
        </div>

    </div>

    <!-- 🎯 ÖLÇÜM KALICI OLSUN BUTONU -->
    <div style="display: flex; flex-direction: row;margin-top:8px;margin-bottom:5px;" *ngIf="kaliciYapilabilirMi">
        <button
            (click)="olcumKaliciYap()"
            style="flex: 1; padding: 0.5rem; background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%); color: white; border: none; border-radius: 4px; cursor: pointer; font-weight: bold; font-size: 0.85rem; display: flex; align-items: center; justify-content: center; gap: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"
            title="Bu ölçümü kalıcı olarak kaydet. Dialog kapatılsa bile ölçüm ürün ağacında görünmeye devam eder.">
            <span>📌</span>
            <span>Ölçüm Kalıcı Olsun</span>
        </button>
    </div>

</div>